@include generate-font-family-vars();

:host {
  @include generate-font-size-vars;
  @include generate-spacing-vars;

  --footer-background-color: #222;
  --footer-color: #959799;
  --footer-background-icon: #fff;
  --footer-icon-color: #222;
  --footer-item-color: #959799;
  --footer-font-family-fallback: "72 Brand Variable", Arial, Helvetica, sans-serif;
  --footer-font-family: var(--cxs-font-family-regular);
  --footer-social-headline-size: 15px;
  --footer-navigation-item-size: 12px ;
}

@import "ds-footer";
